module.exports = __webpack_public_path__ + "media/svg-new/pdf-document-1f849a27.svg";